import SignUpForm from './SignUpForm';
import { Link } from 'react-router-dom';
import LinkButton from '../../utils/LinkButton';
import Logo from '../../ui/components/Logo';
import { CustomButton } from '../../utils/Button';

function SignUp() {
  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      <div className="md:w-1/3 hidden md:block h-screen p-5 lg:py-5 lg:px-0">
        <img
          src="/images/groupsignupImage.svg"
          // src="/images/signupImage.webp"
          className="h-[90%] object-contain w-full"
          alt="Background"
          loading="eager"
        />
      </div>

      <div className="flex-1 p-5 pt-5 lg:w-2/3 ">
        <div className="flex justify-between items-center mb-10 lg:justify-end lg:pr-8 ">
          <Logo />
          <div className="md:hidden mt-[-12px]">
            <Link
              to="/login"
              className="text-dark underline text-sm font-bold font-duplet"
            >
              Log in
            </Link>
          </div>
        </div>

        <div className="max-w-md mx-auto">
          <div className="text-center md:text-left">
            <h1 className="text-xl font-bold">Create your free account</h1>
            <p className="text-sm text-[#222224] font-duplet w-[186px] md:w-full mx-auto md:mx-0">
              Welcome, please create your account to get started
            </p>
          </div>

          <SignUpForm />

          <div className="text-center mt-">
            <p className="text-sm">
              By clicking Create account, you agree to our
            </p>
            <p className="text-sm">
              <Link to="#" className="text-[#0D6EFD] underline ">
                Terms of use
              </Link>{' '}
              and{' '}
              <Link to="#" className="text-[#0D6EFD] underline">
                privacy policy
              </Link>
            </p>
          </div>

          <div className="my-6 hidden lg:block">
            <hr className="border-t-2 border-gray-200" />
          </div>

          <div className="hidden lg:block text-center">
            <p>Already have an account?</p>
            <Link to="/login" className="block w-full">
              <CustomButton
                text="Log in"
                bgColor="#FFF8CF"
                hoverColor="#FACC15"
                width="100%"
                textSize="1.125rem"
                fontWeight="700"
                borderRadius="40px"
                className="text-center py-3 mt-2 text-black hover:bg-yellow-400"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUp;
